// src/components/Utils/ImagePrefetcher.js
import { useEffect } from 'react';
import { descripcionesPlatos, modals } from './DescripcionesPlatos';

// Importamos assets críticos para asegurar que se precarguen primero
import Logotipo from "../../img/Logotipo.webp";
import fondo1 from "../../img/fondo1.webp";

const ImagePrefetcher = () => {
  useEffect(() => {
    // 1. Assets Críticos (Logos, UI principal)
    const criticalAssets = [
      Logotipo,
      fondo1,
      // Añade aquí más iconos o fondos de la pantalla inicial
    ];

    // 2. Extraemos todas las URLs de platos y modales
    const plateUrls = new Set();
    Object.values(descripcionesPlatos).forEach((plato) => {
      if (plato.productoImg) plateUrls.add(plato.productoImg);
    });

    const modalUrls = new Set();
    if (modals && Array.isArray(modals)) {
      modals.forEach((modal) => {
        if (modal.img) modalUrls.add(modal.img);
      });
    }

    // 3. Función para cargar imágenes de forma secuencial o controlada
    const loadImages = async (urls, batchSize = 3, delay = 1000) => {
      const urlArray = Array.from(urls);
      for (let i = 0; i < urlArray.length; i += batchSize) {
        const batch = urlArray.slice(i, i + batchSize);
        await Promise.all(
          batch.map((url) => {
            return new Promise((resolve) => {
              const img = new Image();
              img.src = url;
              img.onload = resolve;
              img.onerror = resolve; // Resolvemos igual para no bloquear la cola
            });
          })
        );
        // Pequeña espera entre lotes para dejar respirar la red
        await new Promise((r) => setTimeout(r, delay));
      }
    };

    const startPrefetch = async () => {
      // Primero: Carga INMEDIATA de assets críticos
      console.log("[Prefetch] Cargando assets críticos...");
      await loadImages(criticalAssets, 5, 0);

      // Segundo: Espera a que el resto de la App se asiente (clima de red tranquilo)
      setTimeout(async () => {
        console.log("[Prefetch] Cargando modales y promociones...");
        await loadImages(modalUrls, 2, 500);

        console.log("[Prefetch] Cargando platos del menú (segundo plano)...");
        await loadImages(plateUrls, 2, 800);
        
        console.log(`[Prefetch] Finalizado. Total: ${plateUrls.size + modalUrls.size + criticalAssets.length} assets.`);
      }, 5000); // 5 segundos para asegurar que el usuario ya ve la pantalla inicial
    };

    startPrefetch();
  }, []);

  return null;
};

export default ImagePrefetcher;
